export default __webpack_public_path__ + "static/media/main-car2.99cb7b61.png";